import { useLayoutEffect, useRef } from "react";
import appHistory from "../../../app/appHistory";
import { locationSlice } from "../locationReducer";
import { useDispatch, useSelector } from "react-redux";
import { LOCATION_COMPONENTS_SEARCH_PARAMS } from "../locationConstants";
import { getIsLocationInitedSelector } from "../locationSelectors";

function useLocationInitOriginParams() {
    const dispatch = useDispatch();
    const isLocationInited = useSelector(getIsLocationInitedSelector);
    const isOriginParamsInited = useRef(false);

    useLayoutEffect(() => {
        if (isLocationInited && !isOriginParamsInited.current) {
            const originSearch = appHistory.location.search;
            const searchParams = new URLSearchParams(originSearch);
            dispatch(locationSlice.actions.setOriginParamsAction({
                originSearch: Object.values(LOCATION_COMPONENTS_SEARCH_PARAMS).some(key => searchParams.has(key))
                    ? originSearch
                    : '',
            }));
            isOriginParamsInited.current = null;
        }
    }, [dispatch, isLocationInited]);
}

export default useLocationInitOriginParams;
